import { cssJoin } from '@volvo-cars/css/utils';
import { CSSProperties, useRef } from 'react';
import { Transition } from 'react-transition-group';

import styles from './Tooltip.module.css';

export type TooltipPlacement = 'top' | 'bottom' | 'right' | 'left';

type TooltipProps = {
  text: string;
  placement: TooltipPlacement;
  visible: boolean;
  maxWidth?: number;
  margin?: number;
  children: React.ReactNode;
};

const Tooltip: React.FC<TooltipProps> = ({
  children,
  placement,
  text,
  visible,
  margin = 10,
  maxWidth = 200,
}) => {
  const nodeRef = useRef(null);

  const style = {
    '--offset': `${margin}px`,
    '---max-width': `${maxWidth}px`,
  } as CSSProperties;

  return (
    <div style={{ position: 'relative' }}>
      <Transition
        nodeRef={nodeRef}
        timeout={200}
        in={visible}
        mountOnEnter
        unmountOnExit
      >
        {(state) => (
          <span
            ref={nodeRef}
            className={cssJoin(
              'micro',
              styles.base,
              styles[placement],
              state.startsWith('enter') && styles.show,
            )}
            style={style}
          >
            {text}
          </span>
        )}
      </Transition>
      {children}
    </div>
  );
};

export default Tooltip;
